import React from 'react';
import { Lock, BadgeCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white py-12 px-6 lg:px-8 border-t border-brand-light text-center md:text-left" data-id="element-87">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-88">
        <div className="flex flex-col items-center md:items-start" data-id="element-89">
          <div className="flex items-center gap-1 mb-2" data-id="element-90">
            <span className="text-2xl font-extrabold text-brand-navy tracking-tight" data-id="element-91">
              INMO
            </span>
            <span className="text-2xl font-extrabold text-brand-accent tracking-tight" data-id="element-92">
              PACK
            </span>
          </div>
          <p className="text-sm text-brand-navy/60 max-w-xs" data-id="element-93">
            El sistema profesional para corredores inmobiliarios en Argentina.
          </p>
        </div>

        <div className="flex flex-col items-center md:items-end gap-4" data-id="element-94">
          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-brand-navy/70" data-id="element-95">
            <div className="flex items-center gap-2" data-id="element-96">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-97" />
              <span data-id="element-98">Pago 100% seguro</span>
            </div>
            <span className="text-brand-navy/20" data-id="element-99">·</span>
            <div className="flex items-center gap-2" data-id="element-100">
              <BadgeCheck className="w-4 h-4 text-brand-green" data-id="element-101" />
              <span data-id="element-102">Pago único, sin suscripciones</span>
            </div>
          </div>
          <div className="flex gap-6 text-sm font-medium text-brand-navy/70" data-id="element-103">
            <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-104">
              Contacto
            </a>
            <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-105">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-106">
              Privacidad
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-brand-light text-xs text-brand-navy/40 text-center" data-id="element-107">
        <p data-id="element-108">
          © {new Date().getFullYear()} INMOPACK — Megapack Agente PRO. Todos
          los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-109">
          Prohibida su reproducción total o parcial. Este sitio no es parte del
          sitio web de Facebook o Facebook Inc. Además, este sitio NO está
          respaldado por Facebook de ninguna manera. FACEBOOK es una marca
          registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}